import { CiCreditCard1 } from 'react-icons/ci';
import { FaApple, FaApplePay } from 'react-icons/fa6';
import ImageWithFallback from '../shared/ImageWithFallback';
export default function SelectedDeposit({
  selectedPaymentMethod,
  setSelectedPaymentMethod
}) {
  if (!selectedPaymentMethod) return null;
  const renderPaymentOption = () => {
    switch (selectedPaymentMethod) {
      case 'coinbase_account':
        return <div className='flex items-center text-genius-cream text-[12px]'>
            <ImageWithFallback src='/icons/coinbase.png' alt='coinbase' width={16} height={16} className='mr-2' />
            Coinbase
          </div>;
      case 'binance':
        return <div className='flex items-center text-genius-cream text-[12px]'>
            <ImageWithFallback src='/icons/binance.png' alt='binance' width={16} height={16} className='mr-2' />
            Binance
          </div>;
      case 'apple':
        return <div className='flex items-center text-genius-cream text-[12px]'>
            <FaApplePay className='text-white w-[16px] h-[16px] mr-2' />
            Apple Pay
          </div>;
      case 'google':
        return <div className='flex items-center text-genius-cream text-[12px]'>
            <ImageWithFallback src='/icons/google.png' alt='google' width={16} height={16} className='mr-2' />
            Google Pay
          </div>;
      case 'card':
        return <div className='flex items-center text-genius-cream text-[12px] justify-between'>
            <div className='flex items-center'>
              <CiCreditCard1 className='text-white w-[16px] h-[16px] mr-2' />
              Credit / Debit
            </div>
          </div>;
      case 'bank':
        return <div className='flex items-center text-genius-cream text-[12px] justify-between'>
            <div className='flex items-center'>
              <CiCreditCard1 className='text-white w-[18px] h-[18px] mr-2' />
              Bank Account
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div onClick={() => setSelectedPaymentMethod(null)} className='rounded-full ta-l mt-4 m-auto ta-c border-genius-blue border-[1px] cursor-pointer flex items-center px-3 py-1 text-[12px] w-fit' data-sentry-component="SelectedDeposit" data-sentry-source-file="SelectedDeposit.tsx">
      {renderPaymentOption()}
    </div>;
}